import React from "react";
import IncentivoCompetenciaShellBoxContainer from "./IncentivoCompetenciaShellBox";

const IncentivoCompetenciaShellBox = (props) => {
  return (
      <IncentivoCompetenciaShellBoxContainer location={props.location} history={props.history} match={props.match}/>
  );
};

export default IncentivoCompetenciaShellBox;
